import React, { useRef, useEffect } from "react";

type SingleLineDataEditorProps = {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur: () => void;
};

const SingleLineDataEditor: React.FC<SingleLineDataEditorProps> = ({
  value,
  onChange,
  onKeyDown,
  onBlur,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  // Autofocus on mount
  useEffect(() => {
    const input = inputRef.current;
    if (input) {
      input.focus();
      if (typeof input.setSelectionRange === "function") {
        input.setSelectionRange(value.length, value.length);
      }
    }
  }, []);

  return (
    <input
      ref={inputRef}
      className="data-editor"
      value={value}
      onChange={e => onChange(e.target.value)}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
    />
  );
};

export default SingleLineDataEditor;
